import * as types from './types';
import { toastType, createToast } from 'Common/ToastHelper';
import { loading } from 'State/actions';

export const getResultsCounts = () => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.VERIFICATION_RESULTS_LETTERS_LOADING, true));

    try {
      const response = await MPWWebApi.getGeneric(
        'Verification/ResultsLetters/Counts'
      );

      dispatch({
        type: types.VERIFICATION_RESULTS_LETTERS_GET_COUNTS,
        payload: response.data.Data ? response.data.Data : 'No Data',
      });
    } catch (error) {
      dispatch({
        type: types.VERIFICATION_RESULTS_LETTERS_ERROR,
        payload: error.response,
      });
    }

    dispatch(loading(types.VERIFICATION_RESULTS_LETTERS_LOADING, false));
  };
};

export const getResultsLetters = values => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.VERIFICATION_RESULTS_LETTERS_LOADING, true));
    try {
      const response = await MPWWebApi.postGenericInsertUpdate(
        `Verification/ResultsLetters`,
        values
      );
      dispatch({
        type: types.VERIFICATION_RESULTS_LETTERS_GET_REPORT,
        payload:
          response.data.Data && response.data.Data.Report
            ? response.data.Data.Report
            : 'No Data',
      });
      dispatch({
        type: types.VERIFICATION_RESULTS_LETTERS_UPDATE_SELECTED,
        payload: response.data.Data.SelectedHouseholds,
      });
    } catch (error) {
      dispatch({
        type: types.VERIFICATION_RESULTS_LETTERS_ERROR,
        payload: error.response,
      });
    }

    dispatch(loading(types.VERIFICATION_RESULTS_LETTERS_LOADING, false));
  };
};

export const writeSuccess = SelectedHouseholds => {
  return async (dispatch, getState, MPWWebApi) => {
    try {
      const response = await MPWWebApi.postGenericInsertUpdate(
        `Verification/ResultsLetters/Success`,
        SelectedHouseholds
      );

      dispatch({
        type: types.VERIFICATION_RESULTS_LETTERS_GET_COUNTS,
        payload: response.data.Data ? response.data.Data : 'No Data',
      });
    } catch (error) {
      dispatch({
        type: types.VERIFICATION_RESULTS_LETTERS_ERROR,
        payload: error.response,
      });
      createToast(toastType.error, 'Error', 'Failed to update Letter history.');
    }
  };
};

export const clearReport = () => {
  return dispatch => {
    dispatch({ type: types.VERIFICATION_RESULTS_LETTERS_CLEAR_REPORT });
  };
};



// WEBPACK FOOTER //
// ./src/pages/resultsletters/state/report/actions.js